import axios from 'axios';
import { ParkingLot, ParkingPrice } from '../../domain/parking';
import { PARKING_SERVICE_ENDPOINTS } from './parking.service.config';
import { CancelParkingVoucherReqParams, GetOrderReqParams, GetParkingPriceReqParams } from './parking.service.type';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export class ParkingService {
  private readonly _endpoints: typeof PARKING_SERVICE_ENDPOINTS;

  constructor() {
    this._endpoints = { ...PARKING_SERVICE_ENDPOINTS };
  }

  public async cancelParkingVoucher(params: CancelParkingVoucherReqParams): Promise<any> {
    return (await axiosInstance.post(this._endpoints.cancelParkingVoucher, params)).data;
  }

  public async getOrder(params: GetOrderReqParams): Promise<any> {
    return (await axiosInstance.post(this._endpoints.getOrder, params)).data;
  }

  public async getParkingLots(): Promise<ParkingLot[]> {
    return (await axiosInstance.get(this._endpoints.getParkingLots)).data.data;
  }

  public async getParkingPrice(params: GetParkingPriceReqParams): Promise<ParkingPrice> {
    return (await axiosInstance.post(this._endpoints.getParkingPrice, params)).data.data;
  }
}
